import { gql } from '@apollo/client';

import {
  SubmitMobileVoiceTranscriptDocument,
  type SubmitMobileVoiceTranscriptMutation,
  type SubmitMobileVoiceTranscriptMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation SubmitMobileVoiceTranscript(
      $input: SubmitMobileVoiceTranscriptInput!
    ) {
      submitMobileVoiceTranscript(input: $input)
    }
  `;
}

export const SUBMIT_MOBILE_VOICE_TRANSCRIPT =
  SubmitMobileVoiceTranscriptDocument;
export type {
  SubmitMobileVoiceTranscriptMutation,
  SubmitMobileVoiceTranscriptMutationVariables,
};
